import { FilteringSupport, TableRowFilter } from 'common/table/filtering-support.interface';
import { FindingStatus, Severity } from 'api';
import { FindingTypeGroup } from 'api/model/finding-type-group';

export class FindingsFilteringSupport implements FilteringSupport {
  constructor(private readonly findingsType: 'default' | 'dtrack') {}
  getFilters(): TableRowFilter[] {
    if (this.findingsType === 'default') {
      return [
        {
          type: 'string',
          id: 'filterText',
          defaultValueKey: 'model.finding.properties.filename',
        },
        {
          type: 'enum',
          id: 'severity',
          defaultValueKey: 'model.finding.filter.allSeverities',
          keyTemplate: 'model.finding.severity.',
          enumType: Severity,
        },
        {
          type: 'enum',
          id: 'status',
          defaultValueKey: 'model.finding.filter.allStatus',
          keyTemplate: 'model.finding.status.',
          enumType: FindingStatus,
        },
        {
          type: 'columns',
          id: 'columns',
          defaultValueKey: 'general.columns',
          keyTemplate: 'model.finding.',
        },
      ];
    }
    return [
      {
        type: 'string',
        id: 'filterText',
        defaultValueKey: 'model.finding.properties.filename',
      },
      {
        type: 'enum',
        id: 'group',
        defaultValueKey: 'model.finding.filter.allTypes',
        keyTemplate: 'model.finding.typeGroup.',
        enumType: FindingTypeGroup,
      },
      {
        type: 'enum',
        id: 'severity',
        defaultValueKey: 'model.finding.filter.allSeverities',
        keyTemplate: 'model.finding.severity.',
        enumType: Severity,
      },
      {
        type: 'enum',
        id: 'kev',
        defaultValueKey: 'model.finding.filter.allKEV',
        keyTemplate: 'model.finding.kev.',
        enumType: {
          yes: 'yes',
          no: 'no',
        },
      },
      {
        type: 'enum',
        id: 'status',
        defaultValueKey: 'model.finding.filter.allStatus',
        keyTemplate: 'model.finding.status.',
        enumType: FindingStatus,
      },
      {
        type: 'columns',
        id: 'columns',
        defaultValueKey: 'general.columns',
        keyTemplate: 'model.finding.',
      },
    ];
  }
}
